/**
 * The tab bar's glyphs. Inline SVG rather than an icon font or a library: seven shapes, drawn
 * with `currentColor` so they take the tab's own colour, and nothing to load.
 *
 * Only the phone's bottom bar shows them. On a desk the tabs are words, which is what she has
 * always read; on a phone a word alone at that size is a guess, and iOS has taught everyone to
 * read a tab bar as icon over label.
 */

const PATHS: Record<string, string> = {
  // An inbox tray: things arriving.
  queue: "M3 13h5l1.5 3h5L16 13h5M5 5h14l2 8v6H3v-6l2-8z",
  // A tick in a circle: work to get done.
  actions: "M8.5 12.5l2.5 2.5 5-5.5M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
  // Ruled lines: the log.
  log: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  // A page with a folded corner: the documents she produces.
  reports: "M14 3H6v18h12V7l-4-4zM14 3v4h4M9 12h6M9 16h6",
  // Two people.
  clients:
    "M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM20 20v-1.5a3.5 3.5 0 0 0-2.5-3.35M15.5 4.2a3.5 3.5 0 0 1 0 6.6",
  // A feed.
  sources: "M5 19h.01M5 12a7 7 0 0 1 7 7M5 5a14 14 0 0 1 14 14",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  plus: "M12 5v14M5 12h14",
};

export function Icon({ name }: { name: keyof typeof PATHS | string }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "more" ? 3 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name] ?? ""} />
    </svg>
  );
}
